import { render, staticRenderFns } from "./BankContentSection.vue?vue&type=template&id=1f1a2d1a&scoped=true&"
import script from "./BankContentSection.vue?vue&type=script&lang=js&"
export * from "./BankContentSection.vue?vue&type=script&lang=js&"
import style0 from "./BankContentSection.vue?vue&type=style&index=0&id=1f1a2d1a&prod&lang=sass&"
import style1 from "./BankContentSection.vue?vue&type=style&index=1&id=1f1a2d1a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1a2d1a",
  null
  
)

export default component.exports